export default "__VITE_ASSET__CZtwLXNE__"